import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Icon } from '@iconify/react/dist/iconify.js'
import './SalePageCounter.scss'
// import { setCartElemCurrentUnit, setAllItemsCart, setCartElemQuantityValue } from '../../../store/slices/itemsCart'
import { setAllItemsSaleCart, setSaleCartElemCurrentUnit, setSaleCartElemQuantityValue, setItemsSaleCart } from './../../../store/slices/saleCart';
import useSalePrice from '../../../hooks/SalePageHooks/useSalePrice';
import useFindItemInSaleCart from '../../../hooks/SalePageHooks/useFindItemInSaleCart';

const SalePageCounter = ({ item }) => {
  const [cardUnits, setCardUnits] = useState(['kg'])
  // console.log(cardUnits);
  const dispatch = useDispatch()
  const inCart = useFindItemInSaleCart(item);

  const [showQuantity, setShowQuantity] = useState()
  const [itemSettings, setItemSettings] = useState({quantity: parseFloat(inCart?.quantity) || 0, unit: inCart?.currentUnit || cardUnits[0]})

  useEffect(() => {
    setItemSettings({quantity: parseFloat(inCart?.quantity) || 0, unit: inCart?.currentUnit || cardUnits[0]})
    setShowQuantity(parseFloat((inCart?.quantity ? inCart.quantity : 0)))
  }, [inCart])

  
  const handleSetCount = (value) => {
    setShowQuantity(parseFloat(value))
    setItemSettings({...itemSettings, quantity: parseFloat(value)})
    !inCart && parseFloat(value) > 0 && dispatch(setAllItemsSaleCart(item))
    inCart && parseFloat(value) <= 0 && dispatch(setAllItemsSaleCart(item))
    dispatch(setSaleCartElemQuantityValue({ value: parseFloat(value), elem: item }))
    dispatch(setSaleCartElemCurrentUnit({ elem: { sku: item?.sku }, value: itemSettings.unit }))
  }
  const handleDecrement = () => {
    if (itemSettings.quantity >= item.saleAddStep) {
      setItemSettings({...itemSettings, quantity: parseFloat(itemSettings.quantity - item.saleAddStep)})
    }
    if (itemSettings.quantity <= item.saleAddStep) {
      setItemSettings({quantity: 0, unit: item?.unit})
      inCart && dispatch(setAllItemsSaleCart(item))
    }
    dispatch(setSaleCartElemQuantityValue({ value: parseFloat((itemSettings.quantity-item.saleAddStep).toFixed(1)), elem: item }))
    dispatch(setSaleCartElemCurrentUnit({ elem: { sku: item?.sku }, value: itemSettings.unit }))
  }
  const handleIncrement = () => {
    let itemFixed = {...item, spoPrice: useSalePrice(item.eventCurrentSalesQuantity+parseInt(inCart?.quantity?inCart.quantity:0), item)}

    if (!inCart) {
      dispatch(setAllItemsSaleCart(itemFixed))
      dispatch(setSaleCartElemQuantityValue({ value: parseFloat((item.saleAddStep).toFixed(1)), elem: itemFixed }))
    }
    inCart && dispatch(setSaleCartElemQuantityValue({ value: parseFloat((itemSettings.quantity+item.saleAddStep).toFixed(1)), elem: itemFixed }))
    dispatch(setSaleCartElemCurrentUnit({ elem: { sku: itemFixed?.sku }, value: itemSettings.unit }))
  }

  return (
    <div className='SalePageCounter' key={item._id+'Counter_salePage'}>
      {inCart && <div 
        className='SalePageCounter__decriment'
        onClick={handleDecrement}
      >
        <Icon icon="akar-icons:minus" />
      </div>}
      <div className='SalePageCounter__weight'>
        {inCart?.quantity ? inCart.quantity : 0}kg
      </div>
      {(parseInt(inCart?.quantity?inCart.quantity:0)+item.eventCurrentSalesQuantity) < item.eventStockQuantity && <div 
        className='SalePageCounter__incriment'
        onClick={() => (item.eventCurrentSalesQuantity+parseInt(inCart?.quantity?inCart.quantity:0)) < item.eventStockQuantity ? handleIncrement() : handleSetCount((item.eventStockQuantity-item.eventCurrentSalesQuantity).toFixed(1))}
      >
        <Icon icon="akar-icons:plus" />
      </div>}
    </div>
  )
}

export default SalePageCounter